/* eslint-disable */
import React from 'react'
import {message, Pagination, Table} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import CheckboxTree from 'react-checkbox-tree'
import cookie from 'react-cookies'
import SECURITY from '../BaseComponent/SECURITY'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'

class EditPermision extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      permission: [],
      checked: [],
      list: [],
      parent: [],
      cats: [],
      permisionModal: false,
      changeTraversal: false
    }
  }
  componentDidMount() {
    http.get(`${SECURITY.SECURITY_MANAGE_LIST_PERMISSION}?showCheckbox=false`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          permission: response.data.object.tree,
          list: response.data.object.list,
          parent: response.data.object.parent
        })
      } else {
        // message.error(response.data.description)
      }
    })
  }

  clickRole = (targetNode) => {
    this.setState({
      permisionModal: !this.state.permisionModal
    })

    var nodeValue = targetNode.value
    for (let i = 0; i < this.state.list.length; i++) {
      let object = {
        id: this.state.list[i].id
      }

      var index = this.state.list.findIndex((list) => list.id === nodeValue)
    }

    var nodeTraversal = this.state.list[index].traversal
    var nodeTitle = this.state.list[index].title

    sessionStorage.setItem('nodeTraversal', nodeTraversal)
    sessionStorage.setItem('nodeValue', nodeValue)
    sessionStorage.setItem('nodeTitle', nodeTitle)
    if (targetNode.isLeaf) {
      this.setState({
        changeTraversal: true
      })
    } else {
      this.setState({
        changeTraversal: false
      })
    }
  }

  cancelOk = () => {
    this.setState({
      permisionModal: !this.state.permisionModal
    })
    sessionStorage.removeItem('nodeTraversal')
    sessionStorage.removeItem('nodeValue')
    sessionStorage.removeItem('nodeTitle')
  }

  tooglePermision = () => {
    this.setState({
      permisionModal: !this.state.permisionModal
    })
    sessionStorage.removeItem('nodeTraversal')
    sessionStorage.removeItem('nodeValue')
    sessionStorage.removeItem('nodeTitle')
  }

  editOk = () => {
    let nodeValue = sessionStorage.getItem('nodeValue')

    if (this.state.changeTraversal) {
      var traversal = document.getElementById('traversal').value
      var title = document.getElementById('title').value
      if (title == '') {
        message.error('عنوان دسترسی را وارد کنید')
      } else {
        var data = {
          permissionId: nodeValue,
          traversal,
          title
        }
        http
          .post(`${SECURITY.SECURITY_MANAGE_EDIT_PERMISSION}`, data, {})
          .then((response) => {
            if (response.data.error == null) {
              message.success('ویرایش دسترسی با موفقیت انجام شد')
              this.setState({
                permisionModal: !this.state.permisionModal
              })
              http.get(`${SECURITY.SECURITY_MANAGE_LIST_PERMISSION}?showCheckbox=false`, {}).then((response) => {
                if (response.data.error == null) {
                  this.setState({
                    permission: response.data.object.tree,
                    list: response.data.object.list,
                    parent: response.data.object.parent
                  })
                } else {
                  // message.error(response.data.description)
                }
              })
            } else {
              this.setState({
                permisionModal: !this.state.permisionModal
              })
              message.error(response.data.description)
            }
          })
          .catch((error) => {})
      }
    } else {
      var title = document.getElementById('title').value
      if (title == '') {
        message.error('عنوان دسترسی را وارد کنید')
      } else {
        var data = {
          permissionId: nodeValue,
          title
        }
        http
          .post(`${SECURITY.SECURITY_MANAGE_EDIT_PERMISSION}`, data, {})
          .then((response) => {
            if (response.data.error == null) {
              this.setState({
                permisionModal: !this.state.permisionModal
              })
              message.success('ویرایش دسترسی با موفقیت انجام شد')
              http.get(`${SECURITY.SECURITY_MANAGE_LIST_PERMISSION}?showCheckbox=false`, {}).then((response) => {
                if (response.data.error == null) {
                  this.setState({
                    permission: response.data.object.tree,
                    list: response.data.object.list,
                    parent: response.data.object.parent
                  })
                } else {
                  // message.error(response.data.description)
                }
              })
            } else {
              this.setState({
                permisionModal: !this.state.permisionModal
              })
              message.error(response.data.description)
            }
          })
          .catch((error) => {})
      }
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  onExpand = (expandedKeys) => {
    console.log('onExpand', expandedKeys)
    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.
    this.setState({
      expandedKeys,
      autoExpandParent: false
    })
  }

  render() {
    let titlePermission = sessionStorage.getItem('nodeTitle')
    let getTraversal = sessionStorage.getItem('nodeTraversal')
    return (
      <div className="rtl editPersmision">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>کاربران</li>
            <li>دسترسی</li>
          </ul>
          <div style={{marginTop: 70}}>
            <CheckboxTree
              nodes={this.state.permission}
              expanded={this.state.expanded}
              onClick={this.clickRole}
              onExpand={(expanded) => this.setState({expanded})}
              optimisticToggle={false}
            />
          </div>
        </div>
        <Modal isOpen={this.state.permisionModal} toggle={this.tooglePermision} size="sm">
          <ModalHeader toggle={this.tooglePermision}>ویرایش دسترسی {titlePermission}</ModalHeader>
          <ModalBody>
            <figure>
              <label>عنوان : </label>
              <input className="form-control" type="text" id="title" defaultValue={titlePermission} />
            </figure>

            <figure style={this.state.changeTraversal ? {display: 'block'} : {display: 'none'}}>
              <label>فیلد خطرناک : </label>
              <select className="form-control" id="traversal">
                <option selected={getTraversal == 'true' ? true : false} value={1}>
                  فعال
                </option>
                <option selected={getTraversal == 'false' ? true : false} value={0}>
                  غیر فعال
                </option>
              </select>
            </figure>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.cancelOk}>
              بستن
            </button>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default EditPermision
